import { forwardRef } from 'react';
import styled from 'styled-components';
import { mixinSkeletonScreen } from '@/public/template/common/css/setting/mixin';

const LoadingModule = styled.div`
  ${mixinSkeletonScreen({
    listHeight: 104,
    articleCount: 10,
    left: 4,
    width: 'calc(100% - 8px)',
    position: 95
  })}

  .newsFeed_list,
  .newsFeed_more {
    display: none;
  }
`;

interface Props {
  readonly id?: string;
  readonly isLoading: boolean;
  readonly children?: React.ReactNode;
}

const NewsFeed = forwardRef<HTMLDivElement, Props>((props, ref) => {
  // newsFeed実装時にclassNameは消す。
  if (props.isLoading) {
    return (
      <LoadingModule id={props.id} ref={ref} className="newsFeed">
        {props.children}
      </LoadingModule>
    );
  }
  return (
    <div id={props.id} ref={ref} className="newsFeed">
      {props.children}
    </div>
  );
});

export default NewsFeed;
